import style from "./style.scss";
import { toChildArray } from "preact";
import { mergeClasses } from "../helpers";

const ButtonBar = ({ class: className = null, children, ...props }) => {
  const mergedClass = mergeClasses([style.buttonBar, className]);
  const items = toChildArray(children);

  return (
    <ul class={mergedClass} {...props}>
      {items.map((child, i) => (
        <li key={i}>{child}</li>
      ))}
    </ul>
  );
};

export default ButtonBar;
